import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Base64ImagePipe } from './base64-image.pipe';
import { LocalCurrencyPipe } from './local-currency.pipe';



@NgModule({
  declarations: [
    Base64ImagePipe,
    LocalCurrencyPipe,
  ],
  imports: [
    CommonModule
  ],
  exports: [Base64ImagePipe, LocalCurrencyPipe]
})
export class CustomPipeModule { }
